export const AgendaIntegracaoTipo = {
    GOOGLE: 'gogl',
    ZOHO: 'zoho',
}

export type AgendaIntegracaoTipoValue = typeof AgendaIntegracaoTipo[keyof typeof AgendaIntegracaoTipo];

export const AgendaIntegracaoTipoDescritor: Record<string, any> = {
    [AgendaIntegracaoTipo.GOOGLE]: 'Google Calendar',
    [AgendaIntegracaoTipo.ZOHO]: 'Zoho Calendar',
} as const

export type AgendaDto = {
    id?: number;
    titulo?: string;
    usuario_id?: number | null;
    grupo_id?: number | null;
    avisar_minutos?: number | null;
    antecedencia_min?: number | null;
    antecedencia_max?: number | null;
    local?: string;
    obs?: string;
    // Default de natureza ao criar atividade nesta agenda (true → serviço)
    faturavel_default?: boolean;
    integracao_tipo?: AgendaIntegracaoTipoValue;
    integracao_token?: string;
    integracao_webhook_id?: string;
    integracao_agenda_id?: string;
}

